import { recordOrdersExport } from '../api/audit'
import { getPeriodDates } from './time'

const dateTime = (value) => value ? new Date(value).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow' }) : '—'

const diagnosticState = (order) => {
    if (order.outcome === 'expired_open') return 'Истекла'
    if (order.outcome === 'expired_progress') return 'Брошена'
    if (order.status === 'open') return 'Новая'
    if (order.status === 'in_progress') return 'В работе'
    return 'Завершена'
}

const deliveryState = (order) => {
    if (!order.is_sent) return 'Не отправлено'
    return order.delivery_method === 'manual' ? 'Отправлено вручную' : 'Отправлено автоматически'
}

const vibeBreakdown = (details = {}) => [
    `открытий: ${details.visits || 0}`,
    `прокрутка: ${details.scrolled ? 'да' : 'нет'}`,
    `фото: ${details.photosOpened || 0}`,
    `все фото: ${details.allPhotosOpened ? 'да' : 'нет'}`,
    `действие: ${details.actionTaken ? 'да' : 'нет'}`,
].join('; ')

export async function exportDiagnostics({ orders, token, filters = {} }) {
    const XLSX = await import('xlsx')
    const toRow = async (order) => {
        let issues = []
        try {
            const response = await fetch(`/api/diagnostic/results/${order.id}`, { headers: { Authorization: `Bearer ${token}` } })
            const results = await response.json()
            if (Array.isArray(results)) {
                issues = results
                    .filter(result => result.status === 'critical' || result.status === 'warning')
                    .map(result => `${result.item_name}${result.side && result.side !== 'none' ? ` (${result.side === 'left' ? 'лев.' : 'прав.'})` : ''}`)
            }
        } catch { /* The export can still include the order if its checklist is unavailable. */ }

        return {
            'Дата периода (МСК)': dateTime(order.period_at || order.completed_at || order.approved_at || order.created_at),
            'Дата создания': dateTime(order.created_at),
            'ID заявки': order.id,
            'Заказ-наряд': order.number || '—',
            'Салон': order.salon_name || '—',
            'Автомобиль': `${order.car_brand || ''} ${order.car_model || ''} ${order.car_year || ''}`.trim(),
            'Госномер': order.plate || '—',
            'VIN': order.vin || '—',
            'Клиент': order.client_name || '—',
            'Телефон': order.client_phone || '—',
            'Мастер-консультант': order.master_name || '—',
            'Механик': order.mechanic_name || '—',
            'Состояние диагностики': diagnosticState(order),
            'Состояние отправки': deliveryState(order),
            'Взята в работу': dateTime(order.in_progress_at),
            'Диагностика завершена': dateTime(order.completed_at || order.approved_at),
            'Заключение подтверждено': dateTime(order.summary_confirmed_at),
            'Отправлено клиенту': dateTime(order.sent_at),
            'Требует внимания': issues.join(', ') || '—',
            'Итоговое заключение': order.client_summary || order.mechanic_summary || '—',
            'Индекс интереса клиента': order.client_interest_score ?? '—',
            'Детализация индекса интереса': order.client_interest_details ? vibeBreakdown(order.client_interest_details) : '—',
            'Клиентская ссылка': order.short_url || (order.report_token ? `${window.location.origin}/report/${order.report_token}` : '—'),
        }
    }
    // Network-wide exports must not launch thousands of checklist requests at once.
    const rows = []
    for (let offset = 0; offset < orders.length; offset += 8) {
        rows.push(...await Promise.all(orders.slice(offset, offset + 8).map(toRow)))
    }

    const range = getPeriodDates(filters.period, filters.from || '', filters.to || '')
    await recordOrdersExport(token, rows.length, { ...filters, ...range })
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Диагностики')
    XLSX.writeFile(workbook, `diagnostics_${new Date().toLocaleDateString('ru-RU', { timeZone: 'Europe/Moscow' }).replace(/\./g, '_')}.xlsx`)
}
